import React from 'react';
import Logo from "../Components/Logo";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


export default function Splash(props) {
    const navigate = useNavigate();

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            navigate('/home');
        }, 2000);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [navigate]);

    return (
        <React.Fragment>
            <section className="container-fluid splash">
                <div className="row">
                    <div className="col-12 ">
                        <Logo size={200} />
                    </div>
                    <h2 className="col-12 text-center mt-4 title text-secondary fw-bold">
                        سورج
                    </h2>
                    <h6 className="col-12 text-center mt-4 text-muted text-small-1">
                        اپلیکیشن نظافت، قالی شویی و مبل شویی
                    </h6>
                    <div className="col-12 text-center fixed-bottom mb-3">
                        <div className="spinner-grow text-muted" role="status">

                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}
